module.exports = __webpack_public_path__ + "static/media/admissions.32dac323.png";